import React, { createContext, useContext, useState, useEffect } from 'react';

const ParentContext = createContext();

export const useParent = () => {
  const context = useContext(ParentContext);
  if (!context) {
    throw new Error('useParent must be used within a ParentProvider');
  }
  return context;
};

export const ParentProvider = ({ children }) => {
  // Initialize selectedChild from localStorage if available
  const [selectedChild, setSelectedChild] = useState(() => {
    try {
      const saved = localStorage.getItem('selectedChild');
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      console.error('Error reading selectedChild from localStorage:', error);
      return null;
    }
  });

  // Initialize controlMode from localStorage if available
  const [controlMode, setControlMode] = useState(() => {
    try {
      const saved = localStorage.getItem('parentControlMode');
      return saved ? JSON.parse(saved) : false;
    } catch (error) {
      console.error('Error reading controlMode from localStorage:', error);
      return false;
    }
  });

  // Update localStorage whenever selectedChild changes
  useEffect(() => {
    try {
      if (selectedChild) {
        localStorage.setItem('selectedChild', JSON.stringify(selectedChild));
      } else {
        localStorage.removeItem('selectedChild');
      }
    } catch (error) {
      console.error('Error saving selectedChild to localStorage:', error);
    }
  }, [selectedChild]);

  // Update localStorage whenever controlMode changes
  useEffect(() => {
    try {
      localStorage.setItem('parentControlMode', JSON.stringify(controlMode));
    } catch (error) {
      console.error('Error saving controlMode to localStorage:', error);
    }
  }, [controlMode]);

  const selectChild = (child) => {
    setSelectedChild(child);
    setControlMode(true);
  };

  const exitControlMode = () => {
    setSelectedChild(null);
    setControlMode(false);
  };

  const value = {
    selectedChild,
    controlMode,
    selectChild,
    exitControlMode,
    setSelectedChild
  };

  return (
    <ParentContext.Provider value={value}>
      {children}
    </ParentContext.Provider>
  );
};

export default ParentContext; 